import {Button, Col, Divider, Row, Typography} from "@douyinfe/semi-ui";
import React, { Fragment } from "react";

export default function HomeContent() {

    const { Title } = Typography;

    const [width, setWidth] = React.useState(window.innerWidth - 17);

    const titleStyle = {
        /*color: 'white',*/
        margin: width > 820? '128px 0 40px 0' : '40px 0 40px 0',
        fontSize: width > 820 ? '350%' : '240%',
        lineHeight: '1.2'
    }

    React.useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth - 17);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [])

    return (
        <Fragment>
            <div className={'grid'}>
                <Row type={'flex'} justify="center">
                    <Col xs={22} xl={14}>
                        <Row type={'flex'} justify="center">
                            <Col span={24}>
                                <Title style={ titleStyle }>Your Complete Partner for Cloud Transformation</Title>
                                <Title heading={3} style={{ margin: '25px 0 50px 0'}}>From SaaS development to enterprise cloud migration, we deliver expert consulting and comprehensive solutions to accelerate your business growth.</Title>
                                <Row type={'flex'} justify="center" gutter={16}>
                                    <Col xs={24} lg={12}>
                                        <Button size={'large'} theme={'light'} block style={{ margin: '0 0 16px 0'}}><font style={{ lineHeight: '1.2' }}>Explore Solutions</font></Button>
                                    </Col>
                                    <Col xs={24} lg={12}>
                                        <Button size={'large'} theme={'solid'} block style={{ margin: '0 0 16px 0'}}><font style={{ lineHeight: '1.2' }}>Free Consultation</font></Button>
                                    </Col>
                                </Row>
                                <Title heading={6} style={{ margin: '25px 0 50px 0'}}>Making cloud computing the core driver of your enterprise growth.</Title>
                            </Col>
                        </Row>
                        <Divider margin='16px'/>
                        <Row type={'flex'} justify="center">
                            <Col span={24}>
                                <Title style={ titleStyle }>Our cloud services deliver the <font style={{ color: '#FF73B3' }}>key advantages</font> you need</Title>
                            </Col>
                        </Row>
                        <Row type={'flex'} justify="center" gutter={16}>
                            <Col xs={24} lg={7}>
                                <Title heading={3} style={{ margin: '25px 0 50px 0'}}>Tailored Solutions</Title>
                                <Title heading={6} style={{ margin: '0 0 50px 0'}}>Deep dive into your business needs to deliver customized cloud solutions, not one-size-fits-all templates.</Title>
                            </Col>
                            <Col xs={24} lg={7}>
                                <Title heading={3} style={{ margin: '25px 0 50px 0'}}>Rapid Deployment</Title>
                                <Title heading={6} style={{ margin: '0 0 50px 0'}}>Agile development processes that bring your SaaS products and cloud migration projects to life quickly.</Title>
                            </Col>
                            <Col xs={24} lg={7}>
                                <Title heading={3} style={{ margin: '25px 0 50px 0'}}>End-to-End Support</Title>
                                <Title heading={6} style={{ margin: '0 0 50px 0'}}>Full lifecycle technical support from consultation and planning through deployment and ongoing operations.</Title>
                            </Col>
                        </Row>
                        <Row type={'flex'} justify="center">
                            <Col span={24}>
                                <Divider margin='16px'/>
                            </Col>
                        </Row>
                        <Row type={'flex'} justify="center">
                            <Col span={24}>
                                <Title heading={1} style={{ margin: '50px 0 25px 0', fontSize: '350%', lineHeight: '1.2'}}>Core Services</Title>
                                <Title heading={4}>From consultation to implementation, we provide comprehensive support for your digital transformation.</Title>
                            </Col>
                        </Row>
                        <Row type={'flex'} justify="center" gutter={16}>
                            <Col xs={24} lg={12}>
                                <Title heading={1} style={{ margin: '50px 0 16px 0',}}>SaaS Product Development</Title>
                                <Title heading={6}>Build highly available and scalable SaaS applications on cloud-native architecture. From requirements analysis to product launch, our experienced team helps you rapidly deliver market-ready cloud products.</Title>
                            </Col>
                            <Col xs={24} lg={12}>
                                <Title heading={1} style={{ margin: '50px 0 16px 0',}}>SMB Cloud Migration</Title>
                                <Title heading={6} >Tailored cloud migration solutions for small and medium businesses, covering system migration, data security, and cost optimization. Experience the flexibility and efficiency of cloud computing with minimal risk and investment.</Title>
                            </Col>
                            <Col xs={24} lg={12}>
                                <Title heading={1} style={{ margin: '50px 0 16px 0',}}>Cloud Architecture Consulting</Title>
                                <Title heading={6} >Our cloud architects provide expert consulting services including cloud platform selection, architecture design, performance optimization, and cost analysis to ensure your cloud strategy aligns with business goals.</Title>
                            </Col>
                            <Col xs={24} lg={12}>
                                <Title heading={1} style={{  margin: '50px 0 16px 0',}}>Custom Solutions</Title>
                                <Title heading={6} >Industry-specific cloud solutions tailored to your unique business needs. Whether you're in e-commerce, online education, smart manufacturing, or fintech, we design the optimal technical approach for your success.</Title>
                            </Col>
                            <Col span={24}>
                                <div style={{ margin: '50px 0' }}></div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </Fragment>
    )

}